import { Component, Inject, ElementRef, ViewChild } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
import { Filter } from '../filter/filter.model';
import { MatTableDataSource } from '@angular/material/table';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Sort } from '@angular/material/sort';
import { ManagerService } from 'src/app/services/manager/manager.service';
import { AppService } from 'src/app/services/app/app.service';
import { MoreCourseInfoComponent } from '../courses/more-course-info/more-course-info.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ViewExamsheetComponent } from '../courses/view-examsheet/view-examsheet.component';
import { AssignCourseEmployeeWiseComponent } from '../courses/assign-course-employee-wise/assign-course-employee-wise.component';
import { ConfirmationModalComponent } from '../dialog-modal/confirmation-modal/confirmation-modal.component';
import { DeleteItemComponent } from '../delete-item/delete-item.component';
import { MessageComponent } from '../employees/message/message.component';
import { JobService } from 'src/app/services/job/job.service';
import { SettingsComponent } from '../recruitment/time-clock-card/settings/settings.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import * as moment from "moment";

@Component({
  selector: 'app-view-employee',
  templateUrl: './view-employee.component.html',
  styleUrls: ['./view-employee.component.scss']
})
export class ViewEmployeeComponent {

  @ViewChild('activityLog') activityLog!: ElementRef;

  selectedItemId: any;
  public empStatistics
  public boxArr: any[] = [
    { content_type: 'courses', text: "Total Courses", cont_img: "assets/images/courses/total_courses.png", progress_bar_color: "green-progress", filterBy: "t_c" },
    { content_type: 'course started', text: "Total Courses Started", cont_img: "assets/images/courses/total_course_started.png", progress_bar_color: "orange-progress", filterBy: "t_p" },
    { content_type: 'exam attended', text: "Total Exam Attended", cont_img: "assets/images/courses/total_exam_attended.png", progress_bar_color: "red-progress", filterBy: "tnsc" },
    { content_type: 'course passed', text: "Total Course Passed ", cont_img: "assets/images/courses/total_passed.png", progress_bar_color: "sky-progress", filterBy: "ex_at" },
    { content_type: 'course failed', text: "Total Course Failed", cont_img: "assets/images/courses/total_course_failed.png", progress_bar_color: "purple-progress", filterBy: "m_d" },
    { content_type: 'informational course', text: "Total Informational Course", cont_img: "assets/images/courses/total_informational_course.png", progress_bar_color: "purple-progress", filterBy: "m_d" },
    { content_type: 'exam course', text: "Total Course With Exam", cont_img: "assets/images/courses/total_course_with_exam.png", progress_bar_color: "purple-progress", filterBy: "m_d" },
  ]
  public selectedFilter!: string;
  public isFilterShow: boolean = false;
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public activityArr: any[] = [];
  public bankDetailsArr: any[] = [];
  public bankListArr: any[] = [];
  public filterArr: any[] = [
    { key_name: "First Name", key_val: "employee_first_name", type: 'text' },
    { key_name: "Last Name", key_val: "employee_last_name", type: 'text' },
    { key_name: "Email", key_val: "employee_email", type: 'text' },
    { key_name: "Department", key_val: "department_name", type: 'select' },
    { key_name: "Training Date", key_val: "deadline_date", type: 'date' },
    { key_name: "Deadline Date", key_val: "training_date", type: 'date' },
  ]
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public imageURL: any = GlobalService.imageURL;
  public displayedColumns: string[] = ['course_info', 'completed_practical', 'certificate_access', 'training_date', 'deadline_date', 'course_type',
    'course_status', 'course_progres', 'exam_status', 'action'];
  public dataSource = new MatTableDataSource();
  public count!: any;
  public empData;
  public courseStatistics: any;
  public isSpinnerLoading: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", }
  isFavourite = false;
  title: string = '';

  public sideMenu: any[] = [
    { name: "Activity", id: 0, icon: "local_activity" },
    { name: "Training", id: 1, icon: "folder_shared" },
    { name: "Notes/Meetings", id: 2, icon: "assignment" },
    { name: "Payroll", id: 3, icon: "work" },
    { name: "HR & Docs", id: 4, icon: "insert_drive_file" },
    { name: "Bank Details", id: 31, icon: "insert_drive_file" },
    { name: "Job Experience", id: 7, icon: "insert_drive_file" },
    // { name: "Holiday Data", id: 8, icon: "insert_drive_file" },
    // { name: "Time Off", id: 5, icon: "alarm_off" },
    { name: "Settings", id: 6, icon: "settings_applications" },
  ]
  public selectedSideMenu!: string;
  public arr: any[] = [
    { name: "Current Shift", id: "current_shift", cl: "current", color: "#fd9332", icon: "today", },
    { name: "Upcoming Shift", id: "upcoming_shift", cl: "upcoming", color: "rgba(4, 195, 172, 1)", icon: "event" },
    { name: "Past Shift", id: "past_shift", cl: "past", color: "rgba(134, 103, 255, 1)", icon: "assignment_return" },
    { name: "Approved Roles", id: "approved_roles", cl: "approved", color: "rgba(57, 163, 7, 1)", icon: "supervisor_account" },
    // { name: "Manager", id: "manager", cl: "manager", color: "rgba(254, 76, 138, 1)", icon: "assets/images/icons/manager.svg" },/
    { name: "Message", id: "message", cl: "message", color: "var(--primary-color)", icon: "message" },
  ]
  public objData = {
    training: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    current_shift: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    upcoming_shift: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    past_shift: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    }
  };

  public displayedColClock: string[] = ['title', 'department', 'start_date', 'end_date', 'action'];
  public displayedColPast: string[] = ['company_name', 'company_add', 'title', 'category', 'date', 'time', 'wages'];
  public displayedColUpc: string[] = ['company_name', 'company_add', 'title', 'date', 'time', 'wages'];
  public displayedColCurrent: string[] = ['company_name', 'company_add', 'title', 'department', 'date', 'time', 'wages'];

  public tempColumn: any = [];

  public dataSourceClock = new MatTableDataSource();
  public dataSourcePast = new MatTableDataSource();
  public dataSourceUpc = new MatTableDataSource();
  public dataSourceCurrent = new MatTableDataSource();

  public userType!: string;
  public co_i!: any
  public showModal: boolean = false;
  public employeeId!: any;

  public startDate: any;
  public endDate: any;
  public dateForm!: FormGroup;
  public countPagination!: any
  panelOpenState = false;
  panelOpenState2 = false;

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private managerService: ManagerService,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<ViewEmployeeComponent>,
    private jobService: JobService,
    private recruterService: RecruiterService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private datePipe: DatePipe,) { }

  ngOnInit(): void {

    // this function is used to get the last 15 days data, end date is the today's date
    this.endDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.startDate;
    if (this.endDate) {
      this.startDate = moment().subtract(2, "days").format("yyyy-MM-DD");
    }
    this.dateForm = this.fb.group({
      start: ["", Validators.required],
      end: ["", Validators.required],
    });
    this.dateForm.get("start")?.setValue(this.startDate);
    this.dateForm.get("end")?.setValue(this.endDate);



    this.selectedSideMenu = this.sideMenu[3]["id"]
    this.title = this.sideMenu[3]["name"];
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    const userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'));
    // this.userType = userInfo.u_typ == 0 ? 'company' : 'recruiter';
    this.userType = userInfo.u_typ == 0 ? 'company' : (userInfo.u_typ == 1 ? 'recruiter' : 'admin');
    this.co_i = userInfo.company_id;

    // if (this.userType === 'recruiter') {
    //   this.displayedColPast = ['company_name','title', 'category', 'date', 'time', 'wages'];
    //   this.displayedColUpc = ['company_name', 'title', 'department', 'start_date', 'end_date', 'action'];
    //   this.displayedColCurrent = ['company_name', 'title', 'department', 'start_date', 'end_date', 'action'];
    // }
    // else {
    //   this.displayedColPast = ['title', 'category', 'date', 'time', 'wages'];
    //   this.displayedColUpc = ['title', 'department', 'start_date', 'end_date', 'action'];
    //   this.displayedColCurrent = ['title', 'department', 'start_date', 'end_date', 'action'];
    // }
    this.tempColumn = this.displayedColPast;
    this.employeeId = this.dialogData.employee_id;

    if (this.dialogData) {
      this.onPageChange(1, true)
    }


    this.dateForm.valueChanges.subscribe((value) => {
      const { start, end } = value;
      const startDate = new Date(start);
      const endDate = new Date(end);
      if (startDate > endDate) return;
        if (start && end) {
          this.getActivity();
        }
      
    });
  }

  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.view(this.dialogData.employee_id)
    this.getEmp();
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
  }
  onPageChange(number: number, isInitialLoad: boolean = false) {
    this.config.currentPage = number;
    this.view(this.dialogData.employee_id)
    if (isInitialLoad == false) {
      this.getEmp();
    }
  }
  doFilter = (event: any) => {
    let newVal = event.target?.value
    this.dataSource.filter = newVal.trim().toLocaleLowerCase();
  }
  callApi(obj) {
    this.filterObj = obj
  }
  onSearch(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.objData[type].previousInputValue !== '') {
      this.objData[type].currentPage = 1
      if (this.selectedSideMenu == '1') {
        this.view(this.dialogData.employee_id, type)
      } else if (type == 'current_shift' || type == 'upcoming_shift' || type == 'past_shift') {
        this.getEmp(type);
      }
    }
  }
  onGo(type: string) {
    if (this.objData[type].sh.trim() != '') {
      this.objData[type].currentPage = 1
      if (this.selectedSideMenu == '1') {
        this.view(this.dialogData.employee_id, type)
      } else if (type == 'current_shift' || type == 'upcoming_shift' || type == 'past_shift') {
        this.getEmp(type);
      }
    }
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  onViewExamSheet(element: any) {
    const dialogRef = this.dialog.open(ViewExamsheetComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '70%', minWidth: '280px', maxWidth: "800px" }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  onMoreInfo(element) {
    const dialogRef = this.dialog.open(MoreCourseInfoComponent,
      Object.assign({ data: { data: element } }, this.animationConfig, { width: '55%', minWidth: '300px', maxWidth: "800px", height: '98%', maxHeight: '600px' }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  onCertificateDownload(element: any) {
    this.appService.downloadFile(element.c_img, 'certificate.png')
  }
  view(id, type?: string) {
    this.isSpinnerLoading = true
    let data = {
      co_i: this.co_i,
      employee_id: id,
      sh: type ? this.objData[type].sh : "",
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    if (type) {
      this.objData[type].previousInputValue = this.objData[type].sh;
    }
    this.managerService.viewEmployee(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.isSpinnerLoading = false;
        this.empData = response.data.employee_info
        this.courseStatistics = response.data.assign_course_statistics
        this.dataSource = new MatTableDataSource(response.data.course);
        this.onEmployeeCourseStats()
        this.count = response.data.count

        this.isFavourite = this.empData.u_type == 0 ? false : true;
      }
    })
  }
  changeCertifcateAccess(value: any, item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["em_i"] = this.dialogData.employee_id
    dataObj["is_build"] = item["is_build"]
    // dataObj["m_c_g"] = !value["checked"]
    dataObj["m_c_g"] = value["checked"]
    dataObj["is_e"] = item["is_e"]
    dataObj["is_pr"] = item["is_pr"]
    dataObj["t"] = item["t"]
    value.source.checked = !value.source.checked
    this.confirmationAlert(dataObj, 'certificate access')
  }
  changeCoursePractical(value: any, item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["em_i"] = this.dialogData.employee_id
    dataObj["is_build"] = item["is_build"]
    dataObj["m_c_g"] = item["m_c_g"]
    dataObj["is_e"] = item["is_e"]
    dataObj["is_pr"] = value["checked"]
    dataObj["t"] = item["t"]
    // doing this so value does not get checked untill it is confirmed using confirmation dialog boxes.
    value.source.checked = !value.source.checked
    this.confirmationAlert(dataObj, 'course practical')
  }
  confirmationAlert(dataObj: any, content_type: any) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { dataObj, content_type: content_type }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["confirm_yes"] == true) {
          this.view(this.dialogData.employee_id)
        }
      }
      if (result == undefined) {
        // if(content_type=='course practical'){
        //   return dataObj
        // }
      }
    });
  }
  onEmployeeCourseStats() {
    let value: any;
    this.boxArr.map((item: any) => {
      let content_type = item["content_type"];
      if (content_type == 'courses') {
        item["value"] = this.courseStatistics.total_course
      }
      if (content_type == 'course started') {
        item["value"] = this.courseStatistics.total_started_course
      }
      if (content_type == 'exam attended') {
        item["value"] = this.courseStatistics.total_attend_exam
      }
      if (content_type == 'course passed') {
        item["value"] = this.courseStatistics.total_pass_exam
      }
      if (content_type == 'course failed') {
        item["value"] = this.courseStatistics.total_fail_exam
      }
      if (content_type == 'informational course') {
        item["value"] = this.courseStatistics.total_informational_course
      }
      if (content_type == 'exam course') {
        item["value"] = this.courseStatistics.total_non_informational_course
      }
    })
  }
  onDeleteItem(item: any) {
    let dataObj: any = {}
    dataObj["a_ci"] = item["a_ci"]
    dataObj["t"] = item["t"]
    const dialogRef = this.dialog.open(DeleteItemComponent,
      Object.assign({ data: { content_type: "delete_assign_user", api_type: "delete_content", dataObj: dataObj, } }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["delete_content"] == true) {
          this.view(this.dialogData.employee_id)
        }
      }
    });
  }
  onAssignCourse() {
    let obj = {
      id: this.dialogData.employee_id
    }
    const dialogRef = this.dialog.open(AssignCourseEmployeeWiseComponent, {
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      panelClass: "hire", autoFocus: false,
      height: '100%',
      width: '90%',
      maxHeight: '746px',
      maxWidth: '1182px',
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        this.view(this.dialogData.employee_id)
      }
    });
  }
  onSideMenuChange(item: any) {
    this.clearSearchBox();
    this.title = item["name"];
    this.selectedItemId = "";
    this.selectedSideMenu = item["id"];
    if (this.selectedSideMenu == '6') {
      this.onOpenSetting()
    }
    if (this.selectedSideMenu == '0') {
      this.getActivity()
    }
    setTimeout(() => {
      this.onScroll()
    }, 100)
  }

  onScroll() {
    if (this.activityLog) {
      this.activityLog.nativeElement.parentElement.parentElement.scrollTop = this.activityLog.nativeElement.parentElement.parentElement.scrollHeight;
    }
  }


  // mat-mdc-dialog-surface

  getActivity() {

    let obj = {
      // j_id: this.dialogData.employee_id,
      st_dt: this.datePipe.transform(
        this.dateForm.get("start")?.value,
        "yyyy-MM-dd"
      ),
      ed_dt: this.datePipe.transform(
        this.dateForm.get("end")?.value,
        "yyyy-MM-dd"
      ),
      em_i: this.dialogData.employee_id,
    }

    this.isSpinnerLoading = true;
    this.jobService.getShiftActivity(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.activityArr = [];
          this.activityArr = success.msg;

        }
      },
      error: (error: any) => {
        this.activityArr = [];
        this.isSpinnerLoading = false

      }
    })

  }

  onOpenSetting() {
    const dialogRef = this.dialog.open(SettingsComponent, {
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      minWidth: '300px',
      width: '95%',
      height: '90%',
      maxWidth: '100%',
      data: { r_type: 2, u_t: 3, u_id: [this.dialogData.employee_id], em_i: this.dialogData.employee_id }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
      this.selectedSideMenu = '4';
      this.title = this.sideMenu[4]["name"];
    });
  }
  clearSearchBox(): void {
    this.objData.current_shift.sh = ''
    this.objData.upcoming_shift.sh = ''
    this.objData.training.sh = ''
    this.objData.past_shift.sh = ''
  }
  onMenuBox(item: any) {
    this.clearSearchBox();
    if (item.id == "upcoming_shift") {
      this.displayedColPast = ['company_name', 'company_add', 'title', 'category', 'date', 'time', 'wages'];;
    } else {
      this.displayedColPast = this.tempColumn;
    }
    this.title = item.name;
    // this.selectedItemId = value;

    this.config.currentPage = 1
    this.config.itemsPerPage = this.pageSizeOptions[0]
    this.selectedSideMenu = item.id;
    if (item.id == "message") { //open message model
      this.onAddMessage()
    } else {
      this.getEmp()
    }
    setTimeout(() => {
      this.onScroll()
    }, 100)
  }
  onAddMessage() {
    let dataObj = {
      employee_id: this.dialogData.employee_id
    }
    const dialogRef = this.dialog.open(MessageComponent, {
      data: dataObj, width: '90%', maxWidth: "400px", height: "95%", maxHeight: '470px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["confirm_yes"] == true) {
          this.view(this.dialogData.employee_id)
        }
      }
      if (result == undefined) {
        // if(content_type=='course practical'){
        //   return dataObj
        // }
      }
    });
  }
  getEmp(user_type?: string) {
    
    this.isSpinnerLoading = true;
    let obj: any = {
      type: "", // 1=clockin data, 2= not clockinn data,  3 = upcooming job, 4 = current job,  5 = past working 6=approved_roles
      em_i: this.dialogData.employee_id
    }
    const searchField = user_type ? this.objData[user_type].sh : '';
    if (this.selectedSideMenu == 'current_shift') {
      obj.st = this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
        obj.sh = searchField,
        obj.r_p = this.config.itemsPerPage,
        obj.type = "4"
    }
    else if (this.selectedSideMenu == 'upcoming_shift') {
      obj.st = this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
        obj.sh = searchField,
        obj.r_p = this.config.itemsPerPage,
        obj.type = "3"
    }
    else if (this.selectedSideMenu == 'past_shift') {
      obj.st = this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
        obj.r_p = this.config.itemsPerPage,
        obj.sh = searchField,
        obj.type = "5"
    }
    else if (this.selectedSideMenu == 'approved_roles') {
      obj.type = "6"
    }
    else {
      
    }
    if (user_type) {
      this.objData[user_type].previousInputValue = this.objData[user_type].sh;
    }
    this.jobService.getEmpDetail(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.countPagination = success.count;
          if (this.selectedSideMenu == 'current_shift') {
            this.dataSourceCurrent = new MatTableDataSource(success.msg)
          }
          else if (this.selectedSideMenu == 'upcoming_shift') {
            this.dataSourceUpc = new MatTableDataSource(success.msg)
          }
          else if (this.selectedSideMenu == 'past_shift') {
            this.dataSourcePast = new MatTableDataSource(success.msg)
          }
          else if (this.selectedSideMenu == 'approved_roles') { }
          else { }
        }
      },
      error: (error: any) => {
        this.dataSourceCurrent.data = []
        this.dataSourceUpc.data = []
        this.dataSourcePast.data = []
        this.isSpinnerLoading = false

      }
    })

  }





  toggleFavourite() {
    this.isFavourite = !this.isFavourite;


    // this.isSpinnerLoading = true
    let data = {
      "em_i": this.dialogData.employee_id,
      "is_f": this.isFavourite == true ? 1 : 0
    }
    this.recruterService.addToFavorite(data).subscribe((response: any) => {
      if (response.status == 200) {

      }
    })
  }

  openTypeEditModel(item) {
    // status is approved still user pressess accept button then no need to change the api 
    let data = {
      "em_i": this.dialogData.employee_id,
      "salaried": item === 1 ? 0 : 1,
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { content_type: 'employee type', data_type: 'Change employe type', dataObj: data, item_type: "emp_type" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.dialogData) {
          this.onPageChange(1, true)
        }
      }
    });
  }

  saveChanges(type: any) {
    let data = {
      "em_i": this.dialogData.employee_id,
      "salaried": type === 1 ? 0 : 1,
    }
    this.recruterService.onChangeEmpSalried(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.empData.salaried = data.salaried;
        this.showModal = false;
      }
    }) 
  }  
  
  closeModal() {
    this.showModal = false;
  }

  // openTypeEditModel() {
  //   this.showModal = true;
  // }
            
}